import React from 'react'

import {getAssetUrl} from '../../../../utils'
import type {LngLat} from '../../../map'
import {TariffsMapMarker} from '../TariffsMapMarker'
import marketLogo from './assets/market.svg'
import styleClasses from './classes.module.css'

type Props = {
  coordinates: LngLat
  onClick?: VoidFunction
}

export function Station({coordinates, onClick}: Props) {
  return (
    <TariffsMapMarker coordinates={coordinates}>
      <div className={styleClasses.pin} onClick={onClick}>
        <img alt="market logo" className={styleClasses.img} src={getAssetUrl(marketLogo)} />
      </div>
    </TariffsMapMarker>
  )
}
